import api from './api';

export type ReviewSolution = 'NAC' | 'DLP' | 'WEB_FILTER' | 'EDR';

export interface ReviewCell {
  /** 그달 승인 대상인가. false면 공란 */
  target: boolean;
  written: boolean;
  writer: string | null;
  writtenAt: string | null;
  /** 승인한 사람. 승인 전·대상 아님이면 null */
  approver: string | null;
  roleConflict: boolean;
}

export interface ReviewRow {
  companyName: string;
  cells: Record<ReviewSolution, ReviewCell>;
}

export interface ReviewData {
  period: string;
  /** 202608 이전 — 발행 = 작성완료, 승인 대상 아님 */
  legacy: boolean;
  approvedAt: string | null;
  rows: ReviewRow[];
}

export interface ApproveResult {
  period: string;
  approvedAt: string;
  published: number;
}

/** 결재란을 붙이는 보고서 (PermissionGuard pageType 과 같다) */
export type ApprovalPageType = 'NAC' | 'DLP' | 'EDR_REPORT' | 'WEB_FILTER';

export interface Approval {
  writer: string | null;
  /** ISO. 202608 이전·미작성은 null */
  writtenAt: string | null;
  /** 승인한 사람 — 승인 전이면 null (미리 채우지 않는다) */
  approver: string | null;
  approvedAt: string | null;
}

export type ApprovalQuery =
  | { pageType: 'NAC' | 'DLP' | 'EDR_REPORT'; period: string; companyName: string }
  | { pageType: 'WEB_FILTER'; period: string; companyGroup: string };

export const reportReviewService = {
  async getPeriods(): Promise<string[]> {
    const res = await api.get<{ periods: string[] }>('/report-review/periods');
    return res.data.periods;
  },

  async getReview(period: string): Promise<ReviewData> {
    const res = await api.get<ReviewData>('/report-review', { params: { period } });
    return res.data;
  },

  /** 보고서 결재란 — Viewer도 호출한다 (회사·계열 권한은 서버가 검사) */
  async getApproval(query: ApprovalQuery): Promise<Approval> {
    const res = await api.get<Approval>('/report-review/approval', { params: query });
    return res.data;
  },

  /** 작성완료 — 발행하지 않는다. 발행은 월 승인으로만 */
  async markWritten(query: ApprovalQuery): Promise<void> {
    await api.post('/report-review/write', query);
  },

  async cancelWritten(query: ApprovalQuery): Promise<void> {
    await api.post('/report-review/write/cancel', query);
  },

  /** 월 승인 — 그달 대상 보고서 일괄 발행 (Admin) */
  async approve(period: string): Promise<ApproveResult> {
    const res = await api.post<ApproveResult>('/report-review/approve', { period });
    return res.data;
  },
};
